import type { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import LegalPage from "../pages/legal/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/legal",
    element: <LegalPage />,
  },
  {
    path: "*",
    element: <HomePage />,
  },
];

export default routes;
